var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1429 11.3571H11.3571V18.1429C11.3571 18.5028 11.2142 18.848 10.9596 19.1025C10.7051 19.357 10.3599 19.5 10 19.5C9.64006 19.5 9.29487 19.357 9.04035 19.1025C8.78584 18.848 8.64286 18.5028 8.64286 18.1429V11.3571H1.85714C1.49721 11.3571 1.15201 11.2142 0.897498 10.9596C0.642985 10.7051 0.5 10.3599 0.5 10C0.5 9.64006 0.642985 9.29487 0.897498 9.04035C1.15201 8.78584 1.49721 8.64286 1.85714 8.64286H8.64286V1.85714C8.64286 1.49721 8.78584 1.15201 9.04035 0.897498C9.29487 0.642984 9.64006 0.5 10 0.5C10.3599 0.5 10.7051 0.642984 10.9596 0.897498C11.2142 1.15201 11.3571 1.49721 11.3571 1.85714V8.64286H18.1429C18.5028 8.64286 18.848 8.78584 19.1025 9.04035C19.357 9.29487 19.5 9.64006 19.5 10C19.5 10.3599 19.357 10.7051 19.1025 10.9596C18.848 11.2142 18.5028 11.3571 18.1429 11.3571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconAdd);
export default __webpack_public_path__ + "static/media/buttonIconAdd.5baba5ff60bf0aa10782537c805a59d7.svg";
export { ForwardRef as ReactComponent };